import { useEffect } from 'react';
import { getCanonicalURL } from 'utils/seo';

export const useDynamicMetaTags = (
  title: string,
  description: string,
  shouldIndexWithCanonicalURL: boolean
): void => {
  useEffect(() => {
    document.title = title;
    const metaDescription = document.querySelector<HTMLMetaElement>('meta[name="description"]');

    if (metaDescription) {
      metaDescription.content = description;
    } else {
      const metaTag = document.createElement('meta');
      metaTag.name = 'description';
      metaTag.content = description;
      document.head.appendChild(metaTag);
    }

    // A canonical URL is the same as the current URL, but all lowercase and without any query parameters.
    // This allows Google to understand that all URLs (example: .../jobs/123 and .../JObS/123?query=nimble) are the same page, and that the canonical URL is the one that should be indexed.
    if (shouldIndexWithCanonicalURL) {
      const canonicalURL = getCanonicalURL();

      const existingCanonicalTag = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');

      if (existingCanonicalTag) {
        existingCanonicalTag.href = canonicalURL;
      } else {
        const canonicalTag = document.createElement('link');
        canonicalTag.rel = 'canonical';
        canonicalTag.href = canonicalURL;
        document.head.appendChild(canonicalTag);
      }
    }

    return () => {
      document.title = 'Nimble';
      const metaDescription = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (metaDescription) {
        metaDescription.remove();
      }

      if (shouldIndexWithCanonicalURL) {
        const canonicalTag = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
        if (canonicalTag) {
          canonicalTag.remove();
        }
      }
    };
  }, [title, description, shouldIndexWithCanonicalURL]);
};
